module.exports = __webpack_public_path__ + "img/1792492830844.b34f72b5.png";